const team = {
    teachers: [
        {
            id: "001",
            name: "邱铁",
            image: require("@/assets/image/team/qiutie.png"),
            introduction:
                "邱铁，博士，天津大学智能与计算学部计算机学院教授，博士生导师，入选2018年度教育部长江学者奖励计划（青年长江学者）、天津市杰出青年基金获得者，天津大学北洋学者计划、同年入选天津市131人才计划，ACM中国理事会天津分会秘书长；曾获大连市科学著作二等奖、ACM天津新星奖，中国计算机学会CCF杰出会员、IEEE/ACM高级会员、网络与数据通信专委会常委、物联网专业委员会委员。曾在美国爱荷华州立大学（Iowa State University）电子与计算机工程系作访问学者（2014-2015）。主要从事物联网技术、智慧城市与移动计算，智能大数据分析等相关研究工作。",
        },
        {
            id: "002",
            name: "周晓波",
            image: require("@/assets/image/zhou.jpg"),
            introduction:
                "周晓波，博士，天津大学智能与计算学部计算机学院教授，博士生导师，中国计算机协会高级会员，IEEE高级会员，曾在IEEE SmartIoT、WASA、IEEE TrustCom等多个国际会议担任组委会成员。周晓波于2007年获得中国科学技术大学电子信息科学与技术学士学位，2010年获得中国科学院大学计算机应用技术2022学位，2013年在日本科学技术大学信息科学学院（JAIST）获得博士学位。2014年4月至2015年3月，在芬兰奥卢大学通信工程系担任研究员。他的研究方向包括合作无线通信、无线网络、数据中心网络、车联网、移动VR和移动边缘计算。",
        },
        {
            id: "003",
            name: "徐天一",
            image: require("@/assets/image/team/xutianyi.png"),
            introduction:
                "天津大学智能与计算学部工程师，2022生导师。主要从事工业物联网、区块链、自然语言处理、数据挖掘等相关研究工作。主持和参与多项国家级、省部级自然科学基金项目，近5年在国内外学术期刊和会议上发表20余篇学术论文。担任IT学科创新创业训练基地指导教师，指导学生参加全国大学生机器人大赛RoboMaster机甲大师赛、全国大学生智能汽车竞赛、中国机器人及人工智能大赛等多项高水平各学科竞赛，获得数十项国家级和省部级奖励。",
        },
        {
            id: "004",
            name: "Weisheng Si",
            image: require("@/assets/image/team/weisheng.jpg"),
            introduction:
                "Weisheng Si received the B.S. degree in computer science from Peking University, Beijing, China, the M.S. degree in computer science from the University of Virginia, Charlottesville, VA, USA, and the Ph.D. degree in computer science from the University of Sydney, Sydney, NSW, Australia. He is currently a Senior Lecturer with the School of Computer, Data, and Mathematical Sciences, Western Sydney University, Sydney, NSW, Australia. Prior to this, he was a Postdoctoral Researcher with National ICT Australia. He has authored or coauthored dozens of papers in prestigious journals and conferences so far. His research interests mainly include network security, complex networks, and Internet of Things",
        },
    ],
    docters: [
        {
            id: "1103",
            name: "池建成",
            researchs: "工业大数据分析",
            Enresearchs: "Industrial Big Data Analysis",
            rank: "Ph 3",
            year: "2020",
            EnName: "Chi Jiancheng",
            image: require("@/assets/image/team/1103.jpg"),
        },
        {
            id: "1102",
            name: "张松伟",
            researchs: "工业设备组网优化",
            Enresearchs: "Industrial Equipment Networking Optimization",
            rank: "Ph 3",
            year: "2021",
            EnName: "Zhang Songwei",
            image: require("@/assets/image/team/1102.jpg"),
        },
        {
            id: "1104",
            name: "赵颖颖",
            researchs: "无线感知与行为识别",
            Enresearchs: "Wireless Sensing and Behavior Recognition",
            rank: "Ph 2",
            year: "2021",
            EnName: "Zhao Yingying",
            image: require("@/assets/image/team/1104.jpg"),
        },
        {
            year: "2022",
            id: "1201",
            image: require("@/assets/image/team/Adii.jpg"),
            rank: "22博士生",
            name: "Adil Muhammad",
            EnName: "Adil Muhammad",
            researchs: "工业大数据分析",
            Enresearchs: "Industrial Big Data Analysis",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1201",
            image: require("@/assets/image/team/1201.jpg"),
            rank: "23博士生",
            name: "曹桢瑞",
            EnName: "Cao Zhenrui",
            researchs: "工业大数据分析",
            Enresearchs: "Industrial Big Data Analysis",
            stu_ID: "",
        },

    ],
    masters: [

        {
            year: "2021",
            id: "1202",
            image: require("@/assets/image/team/1202.jpg"),
            rank: "21硕士生",
            name: "沙哲一",
            EnName: "Sha Zheyi",
            researchs: "工控智能协议解析",
            Enresearchs: "Industrial Control Intelligent Protocol Analysis",
            stu_ID: "",
        },
        {
            year: "2021",
            id: "1203",
            image: require("@/assets/image/team/1203.jpg"),
            rank: "21硕士生",
            name: "杨欣捷",
            EnName: "Yang Xinjie",
            researchs: "工业区块链",
            Enresearchs: "Industrial Blockchain",
            stu_ID: "",
        },
        {
            year: "2021",
            id: "1204",
            image: require("@/assets/image/team/1204.jpg"),
            rank: "21硕士生",
            name: "杨欣微",
            EnName: "Yang Xinwei",
            researchs: "工业设备组网优化",
            Enresearchs: "Industrial Equipment Networking Optimization",
            stu_ID: "",
        },
        {
            year: "2022",
            id: "1205",
            image: require("@/assets/image/team/1205.jpg"),
            rank: "22硕士生",
            name: "孙景晨",
            EnName: "Sun Jingchen",
            researchs: "工业设备组网优化",
            Enresearchs: "Industrial Equipment Networking Optimization",
            stu_ID: "",
        },
        {
            year: "2022",
            id: "1206",
            image: require("@/assets/image/team/1206.jpg"),
            rank: "22硕士生",
            name: "任林杰",
            EnName: "Ren Linjie",
            researchs: "工业区块链",
            Enresearchs: "Industrial Blockchain",
            stu_ID: "",
        },
        {
            year: "2022",
            id: "1207",
            image: require("@/assets/image/team/1207.jpg"),
            rank: "22硕士生",
            name: "于逸",
            EnName: "Yu Yi",
            researchs: "工业大数据分析",
            Enresearchs: "Industrial Big Data Analysis",
            stu_ID: "",
        },
        {
            year: "2022",
            id: "1208",
            image: require("@/assets/image/team/1208.jpg"),
            rank: "22硕士生",
            name: "刘兆达",
            EnName: "Liu Zhaoda",
            researchs: "无线感知与行为识别",
            Enresearchs: "Wireless Sensing and Behavior Recognition",
            stu_ID: "",
        },
        {
            year: "2022",
            id: "1208",
            image: require("@/assets/image/team/niuziyu.jpg"),
            rank: "21硕士生",
            name: "牛梓雨",
            EnName: "Niu Ziyu",
            researchs: "工业大数据分析",
            Enresearchs: "Industrial Big Data Analysis",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1205",
            image: require("@/assets/image/team/caosong.jpg"),
            rank: "23硕士生",
            name: "曹颂",
            EnName: "Cao Song",
            researchs: "工业设备组网优化",
            Enresearchs: "Industrial Equipment Networking Optimization",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1205",
            image: require("@/assets/image/team/lijiqiao.jpg"),
            rank: "23硕士生",
            name: "李季桥",
            EnName: "Li Jiqiao",
            researchs: "工业设备组网优化",
            Enresearchs: "Industrial Equipment Networking Optimization",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1205",
            image: require("@/assets/image/team/huangxiaochen.jpg"),
            rank: "23硕士生",
            name: "黄晓琛",
            EnName: "Huang Xiaochen",
            researchs: "工业设备组网优化",
            Enresearchs: "Industrial Equipment Networking Optimization",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1205",
            image: require("@/assets/image/team/xuzhiqiang.jpg"),
            rank: "23硕士生",
            name: "徐志强",
            EnName: "Xu Zhiqiang",
            researchs: "工业大数据分析",
            Enresearchs: "Industrial Big Data Analysis",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1205",
            image: require("@/assets/image/team/suhao.jpg"),
            rank: "23硕士生",
            name: "苏昊",
            EnName: "Su Hao",
            researchs: "工控智能协议解析",
            Enresearchs: "Industrial Control Intelligent Protocol Analysis",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1205",
            image: require("@/assets/image/team/ganziqi.jpg"),
            rank: "23硕士生",
            name: "甘子奇",
            EnName: "Gan Ziqi",
            researchs: "工业区块链",
            Enresearchs: "Industrial Blockchain",
            stu_ID: "",
        },
    ],
    undergraduates: [
        {
            year: "2017",
            id: "1301",
            image: require("@/assets/image/team/1201.jpg"),
            rank: "17级本科生",
            name: "曹桢瑞",
            researchs: "智慧物联网-移动计算",
            stu_ID: "",
        },
    ],
    graduates: [
        {
            year: "2023",
            id: "1401",
            image: require("@/assets/image/team/1401.jpg"),
            rank: "2023毕业生",
            name: "侯凯祥",
            researchs: "智慧物联网-工业物联网",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1402",
            image: require("@/assets/image/team/1402.jpg"),
            rank: "2023毕业生",
            name: "黄慧娟",
            researchs: "智慧物联网-5G位置服务",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1403",
            image: require("@/assets/image/team/1403.jpg"),
            rank: "2023毕业生",
            name: "王玮",
            researchs: "智慧物联网-移动计算",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1404",
            image: require("@/assets/image/team/1404.jpg"),
            rank: "2023毕业生",
            name: "张立地",
            researchs: "智慧物联网-5G组网优化",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1405",
            image: require("@/assets/image/team/1405.jpg"),
            rank: "2023毕业生",
            researchs: "智慧物联网-工业物联网",
            stu_ID: "",
        },
        {
            year: "2023",
            id: "1406",
            image: require("@/assets/image/team/1406.jpg"),
            rank: "2023毕业生",
            name: "王浩东",
            researchs: "智慧物联网-5G组网优化",
            stu_ID: "",
        },
    ],
};
export default team;
